import React from 'react';
import { useTranslation } from "react-i18next";
import "../translations/i18n";

export const Temoignage = () => {
  const {t} = useTranslation();
  const testimonials = [
  {
    image: "/img/avatar.jpg",
    name: "Sandrine Nkurunziza",
    role: "Responsable Marketing",
    text: "Collaborer avec B-Eye nous a permis de renforcer notre image de marque et d'améliorer la qualité de nos contenus digitaux. Leur créativité et leur professionnalisme font toute la différence."
  },
  {
    image: "/img/avatar.jpg",
    name: "Jean Bosco Nduwimana",
    role: "Directeur Commercial",
    text: "Les campagnes visuelles et les supports de communication réalisés par B-Eye ont contribué à accroître notre visibilité et à générer davantage d'opportunités commerciales."
  },
  {
    image: "/img/avatar.jpg",
    name: "Aline Irakoze",
    role: "Responsable Communication",
    text: "L'équipe comprend rapidement les besoins de ses clients et propose des solutions adaptées. Les résultats obtenus ont largement répondu à nos attentes."
  },
  {
    image: "/img/avatar.jpg",
    name: "Thierry Nahimana",
    role: "Business Development Manager",
    text: "Grâce à l'accompagnement de B-Eye, nous disposons aujourd'hui de contenus professionnels qui valorisent notre activité et renforcent la confiance de nos partenaires."
  }
];

  return (
    <section id="testimonials" className="testimonials dashboard-testimonials">
      <div className="container" data-aos="fade-up">
        <div className="dashboard-section-head dashboard-section-head--center">
          <div>
            <span className="dashboard-kicker">Confiance</span>
            <h2>{ t("temoignage.title")}</h2>
          </div>
          <p>{ t("temoignage.description") }</p>
        </div>

        <div className="dashboard-testimonial-grid" data-aos="fade-up" data-aos-delay="100">
          {testimonials.map((item, index) => (
            <div className="testimonial-item" key={item.name} data-aos="fade-up" data-aos-delay={(index + 1) * 80}>
              <div className="dashboard-testimonial-top">
                <img src={item.image} className="testimonial-img" alt={item.name} />
                <div>
                  <h3>{item.name}</h3>
                  <h4>{item.role}</h4>
                </div>
              </div>
              <div className="stars">
                <i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i>
              </div>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
